// extracted by mini-css-extract-plugin
export default {"result":"LoadingComponent_result__2d51t","spin":"LoadingComponent_spin__gwl87","image":"LoadingComponent_image__wyBa0"};